// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/info.js';

import { paths } from '../generated/info';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('info', Original, paths);
